import React from 'react';
import {
  navigationPropsShape,
  SectionNav,
} from 'AppSrc/core/components/forms/section-nav';
import { SectionSummary } from 'AppSrc/core/components/forms/form-base-components/summary-components/section-summary';
import { prefixStringWithIndexPlusOne } from 'AppSrc/core/utility-functions/string-fun';
import { formDataShape } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import { deleteAllIndidualList } from 'AppSrc/core/approvers/approver-individual-actions';
import PropTypes from 'prop-types';
// import {
//   isStatusCoordinator,
//   isStatusCancelled,
// } from 'AppSrc/core/crq/crq-statuses';
import { SummaryError } from 'AppSrc/core/components/forms/form-types/create-crq/section-change-request-summary/summary-error';
import { CHANGE_TYPE } from 'AppSrc/core/components/forms/form-types/create-crq/section-one/section-one';
import { userRolesPropShape } from 'AppSrc/core/auth/auth-proptypes';
import { REQUESTER, COORDINATOR } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import {
  collectErrors,
  getHasErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  getIsOlaCrq,
  currentSelectedNetwork,
  userRoleForSelectedNetwork,
  isCrqEmergency,
  getIsInternationalCrq,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import { CREATE_CRQ } from 'AppSrc/core/components/create-crq-screen/create-crq-screen-consts';
import { connect } from 'react-redux';
import { submitAndUpdateCreateCrqForm } from 'AppSrc/core/actions/actions-create-crq-form';
import { Alert } from 'AppSrc/core/components/utility/alert';
import { deleteAllDataForForm } from 'AppSrc/core/actions/actions-main-form';
import {
  CHANGE_REQUEST_SUMMARY,
  SECTION_TITLES,
} from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import { CRQ_TRANSITION_CONFIRMATION } from 'AppSrc/core/components/router/routes';
import { CRQ_STATUS_TRANSITIONS } from 'AppSrc/core/crq/crq-status-transitions';
import { refreshPouAction } from 'AppSrc/core/pou/pou-actions';
import { LoadingSpinner } from 'AppSrc/core/components/utility/loading-spinner';
import { withRouter } from 'react-router';
// import { WorkflowBar } from './workflow-bar';
import { SelectCrqCoordinatorForm } from './select-crq-coordinator-form';
import { SubmitCreateCrqProgress } from './submit-create-crq-progress';
import { ExpandCollapseAll } from './expand-collapse-all';
import { SelectPeerReviewerForm } from './select-peer-reviewer-form';
import 'AppSrc/core/style/components/form/form-base-components/summary-components/section-summary.css';
// import { WorkflowBar } from '../../../../view-crq-screen/workflow-bar';
// import { ViewCrqMetadata, getImpactLevelDisplay } from '../../../../view-crq-screen/view-crq-metadata';
// import 'AppSrc/core/style/components/view-crq-screen/view-crq-screen.css';

const summaryTitle = SECTION_TITLES[CHANGE_REQUEST_SUMMARY];




class ChangeRequestSummaryDisplay extends React.PureComponent {

  constructor(props) {
    super(props);
    const openStatuses = this.getInitialOpenStatuses();
    this.state = {
      openStatuses,
      submitAttempted: false,
      showConfirmation: false,
    };
    this.toggleOpen = this.toggleOpen.bind(this);
    this.expandAll = this.expandAll.bind(this);
    this.collapseAll = this.collapseAll.bind(this);
    this.generateOpenStatusesArray = this.generateOpenStatusesArray.bind(this);
    this.getInitialOpenStatuses = this.getInitialOpenStatuses.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.submitAttempted = this.submitAttempted.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this);
  }

  componentDidMount() {
    // when arriving on the summary page, refresh the CRQs POU if appropriate
    const { refreshPou } = this.props;
    if (refreshPou) {
      refreshPou();
    }
  }

  getInitialOpenStatuses() {
    const { formSectionsByDisplayOrder, summaryErrors } = this.props.formData;
    return formSectionsByDisplayOrder.map((sectionId) => {
      const sectionErrors = summaryErrors[sectionId];
      const hasError = sectionErrors && Object.keys(sectionErrors).length > 0;
      return hasError;
    });
  }

  toggleOpen(sectionIndex) {
    this.setState((prevState) => {
      // toggle the boolean value of openStatuses[sectionIndex]
      const openStatuses = prevState.openStatuses.map(
        (open, index) => (index === sectionIndex ? !open : open),
      );
      return ({
        openStatuses,
      });
    });
  }

  // Generate array representing the open status of each section
  // sections[3] is open if openStatuses[3] == true
  // initialised all elements with value of `areOpen`
  generateOpenStatusesArray(areOpen) {
    const numSections = this.props.formData.formSectionsByDisplayOrder.length;
    return Array(numSections).fill(areOpen);
  }

  expandAll() {
    this.setState({
      openStatuses: this.generateOpenStatusesArray(true),
    });
  }

  collapseAll() {
    this.setState({
      openStatuses: this.generateOpenStatusesArray(false),
    });
  }



  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      showConfirmation: true,
    });
  }

  handleConfirmation({ boolean }) {
    this.setState({
      showConfirmation: false,
    });

    if (boolean) {
      this.props.submitForm();
    }
  }

  submitAttempted(event) {
    event.preventDefault();
    this.setState({ submitAttempted: true });
  }

  render() {
    const {
      formData,
      // status,
      // crqId,
      navigateToSection,
      navigationProps,
      userRoles,
      // remedyId,
      coordinatorId,
      // coordinatorName,
      // coordinatorGroup,
      peerReviewerId,
      // peerReviewerName,
      // requester,
      // requesterName,
      // statusReason,
      sectionIndex,
      refreshingPou,
      // impactValue,
    } = this.props;
    if (refreshingPou) {
      return (
        <div className="form-loader">
          <LoadingSpinner />
        </div>
      );
    }

    const network = currentSelectedNetwork(formData);
    // is the user a requester for the currently selected network
    const networkRole = userRoles ? userRoles[network] : undefined;
    // const userRole = userRoles[network];
    const userIsRequester = networkRole === REQUESTER;
    const userIsCoordinator = networkRole === COORDINATOR;
    // const isOlaCrq = getIsOlaCrq(formData);
    const changeDetails = 'CHANGE_DETAILS';
    const isOloByService = formData.dataByFormSectionId[changeDetails] ? formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: Other Licensed Operator (OLO)' || formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: International Other Licensed Operator (OLO)' : null;
    const isOlaCrq = getIsOlaCrq(formData) || isOloByService;
    const isEmergency = isCrqEmergency(formData);
    const isIcmCrq = getIsInternationalCrq(formData);

    const errors = collectErrors({
      formData,
    });
    const { summaryErrors, formSectionsByDisplayOrder, dataByFormSectionId } = formData;
    const hasErrors = getHasErrors(errors);
    const hasCoordinator = Boolean(coordinatorId); // is not null, undefined or empty string
    // if the user is coordinator, peer reviewer must be set
    const missingPeerReviewer = userIsCoordinator && !peerReviewerId;
    const canSubmit = isOlaCrq ? !hasErrors : hasCoordinator && !hasErrors && !missingPeerReviewer;
    const onSubmit = canSubmit ? this.handleSubmit : this.submitAttempted;
    // Props for the SectionNav in FormSection. these come from the parent but we mutate them to be relivent to the section
    const filteredNavigationProps = {
      ...navigationProps,
      next: null,
      submitForm: onSubmit,
    };

    const {
      openStatuses,
      submitAttempted,
      showConfirmation,
    } = this.state;
    // Check that the sections are all open apart from index = 0
    const allExpanded = openStatuses.every((open, index) => index === 0 || open);
    // const impactValue = getImpactLevelDisplay(formData);


    const expandCollapse = (
      <ExpandCollapseAll
        className="expand-collapse-all"
        allExpanded={allExpanded}
        collapseAll={this.collapseAll}
        expandAll={this.expandAll}
      />
    );

    const requesterTitle = 'Are you sure you want to submit for coordinator review?';
    const coordinatorTitle = isOlaCrq && !isEmergency ? 'Are you sure you want to submit to Approvals?' : `Are you sure you want to submit for ${isEmergency && !isOlaCrq ? 'L3 Approval?' : 'Peer review?'}`;
    console.log(isIcmCrq);
    const titleToUse = userIsRequester ? requesterTitle : coordinatorTitle;

    const checkMessage = 'Please ensure you have provided/checked the required information/documentation to support your change request to avoid any delays.';
    // data for the confirmation alert
    const alertData = {
      option: null,
      alertTitle: titleToUse,
      alertText: checkMessage,
      falseText: 'Close',
      trueText: 'Submit',
    };


    const formattedSectionTitle = prefixStringWithIndexPlusOne(summaryTitle, sectionIndex);

    const hasReferenceCRQ = () => (((formData.adjacentRemedyRef === null) || (formData.adjacentRemedyRef === undefined)) ? false : true);
    // window.localStorage.setItem('isOloNetwork', isOlaCrq);
    return (
      <form className="formik-form">
        {/* {
          !isOlaCrq && ( */}
        <h3 className="form-section-title">
          {formattedSectionTitle}
        </h3>
        {/* )
        } */}
        {/* {
          isOlaCrq && (
            <div className="view-crq-content">
              <>
                <ViewCrqMetadata
                  formData={formData}
                />
                <WorkflowBar
                  status={status}
                  crqId={crqId}
                  coordinatorName={coordinatorName}
                  coordinatorGroup={coordinatorGroup} // adding coordinator group from workflowbar to use here.
                  peerReviewerName={peerReviewerName}
                  requesterName={requesterName}
                  userRole={userRole}
                  network={network}
                  coordinatorId={coordinatorId}
                  peerReviewerId={peerReviewerId}
                  remedyId={remedyId}
                  // rejectedFromPeer={rejectedFromPeer}
                  requester={requester}
                  // statusReason={statusReason}
                  impactValue={impactValue}
                />
              </>
            </div>
          )
        } */}
        {hasErrors && (
          <SummaryError
            errors={errors}
          />
        )}
        <div className="section-change-request-summary">
          {expandCollapse}
          <div className="sections">
            {
              formSectionsByDisplayOrder.map((sectionId, index) => {
                const formSection = dataByFormSectionId[sectionId];
                const sectionErrors = summaryErrors[sectionId];
                // dont allow the user to change the first section summary
                const readOnly = sectionId === CHANGE_TYPE;
                if (formSection !== null) {
                  return (
                    <SectionSummary
                      key={formSection.sectionTitle}
                      formSection={formSection}
                      sectionIndex={index}
                      navigateToSection={readOnly ? null : navigateToSection}
                      open={openStatuses[index]}
                      toggleOpen={this.toggleOpen}
                      sectionErrors={sectionErrors}
                      selectedNetwork={network}
                      formData={formData}
                      hasReferenceCRQ={hasReferenceCRQ}
                    />
                  );
                }
                return null;
              })
            }
          </div>
          {expandCollapse}
        </div>
        {
          // only show select coordinator form if the user is a requester
          userIsRequester && (
            <SelectCrqCoordinatorForm
              network={network}
              showErrors={submitAttempted}
            />
          )
        }
        {
          // show select peer reviewer form if the user is a coordinator
          userIsCoordinator && (!isOlaCrq || (isOlaCrq && isEmergency)) && (
            <SelectPeerReviewerForm
              network={network}
              showErrors={submitAttempted}
              crqType={CREATE_CRQ}
            />
          )
        }
        <p className="pre-submit-message">
          {checkMessage}
        </p>
        <SectionNav
          navigationProps={filteredNavigationProps}
          readyToSubmit={canSubmit}
        />
        {showConfirmation ? (
          <Alert
            alertData={alertData}
            resolveAlert={this.handleConfirmation}
          />
        ) : null}
        <SubmitCreateCrqProgress />
      </form>
    );
  }
}

ChangeRequestSummaryDisplay.propTypes = {
  // crqId: PropTypes.string,
  navigateToSection: PropTypes.func,
  navigationProps: navigationPropsShape,
  formData: formDataShape,
  userRoles: userRolesPropShape,
  // status: PropTypes.string,
  coordinatorId: PropTypes.string,
  // coordinatorName: PropTypes.string,
  // coordinatorGroup: PropTypes.string,
  // peerReviewerName: PropTypes.string,
  // requester: PropTypes.string,
  // requesterName: PropTypes.string,
  peerReviewerId: PropTypes.string,
  submitForm: PropTypes.func,
  sectionIndex: PropTypes.number,
  refreshPou: PropTypes.func,
  refreshingPou: PropTypes.bool,
  // remedyId: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => {
  const formData = state.mainForm.formData[CREATE_CRQ];
  const { coordinatorId, peerReviewerId } = formData;
  const { refreshingPou } = state.pou;
  return ({
    coordinatorId,
    peerReviewerId,
    refreshingPou,
  });
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  submitForm() {
    const {
      formData,
      userRoles,
    } = ownProps;
    // the new status for the CRQ depends on the users role for the network
    // requesters submit crqs to coordinator review
    // coordinators submit crqs to peer review
    const isOlaCrq = getIsOlaCrq(formData);
    const isEmergency = isCrqEmergency(formData);
    const networkRole = userRoleForSelectedNetwork(formData, userRoles);
    // const isIcmCrq = getIsInternationalCrq(formData);
    // const statusTransition = networkRole === REQUESTER ? CRQ_STATUS_TRANSITIONS.raiseCrq : CRQ_STATUS_TRANSITIONS.submitToPeerReview;
    let tempStatusTransition = '';
    if (networkRole === REQUESTER) {
      tempStatusTransition = CRQ_STATUS_TRANSITIONS.raiseCrq;
    }
    // this to skip approval form emergency
    else if (isOlaCrq) {
      if (isEmergency) {
        tempStatusTransition = CRQ_STATUS_TRANSITIONS.submitToPeerReview;
      }
      if (!isEmergency) {
        tempStatusTransition = CRQ_STATUS_TRANSITIONS.oloSubmitToApproval;
      }
    }
    else if (!isOlaCrq && isEmergency) {
      tempStatusTransition = CRQ_STATUS_TRANSITIONS.submitToL3Approval;
    }
    else {
      tempStatusTransition = CRQ_STATUS_TRANSITIONS.submitToPeerReview;
    }
    const statusTransition = tempStatusTransition;

    // pass the required status to the submit actions
    dispatch(submitAndUpdateCreateCrqForm(statusTransition))
      .then(({ network, crqId }) => {
        const transitionId = statusTransition.id;
        // navigate to the success route, with the correct crqId
        const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({ network, crqId, transitionId });
        ownProps.history.push(successPath);
        // clear all the form data
        dispatch(deleteAllDataForForm(CREATE_CRQ));
        // To delete individual approver list
        dispatch(deleteAllIndidualList());
      })
      .catch((error) => console.warn(error));
  },
  refreshPou() {
    const { editingStatus } = ownProps;
    // dispatch action to refresh POU if necessary
    dispatch(refreshPouAction(editingStatus));
  },
});

const ChangeRequestSummary = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChangeRequestSummaryDisplay));

export {
  CHANGE_REQUEST_SUMMARY,
  ChangeRequestSummary,
  ChangeRequestSummaryDisplay,
};
